import { useQuery } from '@tanstack/react-query';
import { request } from '../../actions/helper';
import { API_STATUS_PROXY_URL } from '../../constants';
import type { Incident } from '../../components/ApiStatusBanner';

export const API_STATUS_QUERY_KEY = ['apiStatus', 'incidents'];

// ECDEX-3840 (slice 1): the status-page incidents the Header banner shows.
// Replaces the apiStatusBanner Redux slice. A failed or missing request means
// no banner, as before, so there is no retry and no error surfaced.
const useApiStatusIncidents = (): Incident[] => {
  const { data } = useQuery<Incident[]>({
    queryKey: API_STATUS_QUERY_KEY,
    queryFn: async () => {
      const { incidents } = await request(API_STATUS_PROXY_URL);
      return incidents || [];
    },
    enabled: Boolean(API_STATUS_PROXY_URL),
    retry: false,
    refetchOnWindowFocus: false,
  });
  return data ?? [];
};

export default useApiStatusIncidents;
